import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import { ArrowLeftOutlined, MenuOutlined } from '@ant-design/icons';

import SearchBar from 'components/Elements/Shared/SearchBar';
import styles from './NavBar.module.css';

const isCardView = (pathname) => Boolean(pathname.match(/^\/m\/cards\/[\w-/]+$/));

const isTransparentSearchBar = (pathname = '') => {
  return Boolean(pathname.match(/^\/m\/decks\/[0-9A-z-]+$/));
};

const Menu = ({ onToggleDrawer, location: { pathname }, history }) => {
  const transparent = isTransparentSearchBar(pathname);
  const canGoBack = isCardView(pathname);

  const onClickIcon = () => {
    if (canGoBack) {
      history.goBack();
    } else {
      onToggleDrawer();
    }
  };

  const iconStyle = transparent
    ? { color: '#fff', filter: 'drop-shadow( 0px 0px 1px rgba(0, 0, 0, .7))' }
    : { color: 'white' };

  iconStyle.padding = '10px 15px 10px 10px';

  if (history.location.pathname.includes('/life-tracker/start')) return null;

  return (
    <>
      <div className={classNames(styles.menu, { [styles.transparent]: transparent })}>
        {canGoBack ? (
          <ArrowLeftOutlined onClick={onClickIcon} style={iconStyle} />
        ) : (
          <MenuOutlined onClick={onClickIcon} style={iconStyle} />
        )}
        <SearchBar transparent={transparent} />
      </div>
      {!transparent && <div className={styles.invisibleWrapper} />}
    </>
  );
};

export default withRouter(Menu);
